import {
  Component,
  computed,
  contentChild,
  inject,
  input,
  signal
} from "@angular/core";
import {
  NotifyNewContentNames,
  NotifyNewContentService
} from "src/app/components/ui/notify-new-content/notify-new-content.service";
import { TemplateDirective } from "src/app/modules/bootstrap/directives/common/template.directive";

@Component({
  selector: "snt-notify-new-content",
  templateUrl: "notify-new-content.component.html",
  styles: `
    :host {
      display: flex;
    }
  `,
  standalone: false
})
export class NotifyNewContentComponent {
  name = input<NotifyNewContentNames | undefined>();
  small = input<boolean>(false);
  hideText = input<boolean>(false);

  enabled = computed(() => {
    const name = this.name()!;

    if (!name) {
      return false;
    }

    return !this.notifyNewContentService.isExpired(name);
  });

  private readonly notifyNewContentService = inject(NotifyNewContentService);

  content = contentChild<TemplateDirective | undefined>(TemplateDirective);
}
